module.exports = __webpack_public_path__ + "html/fuel-form.template.html";